import { InputText } from 'macaron-frontend-ui'
import { useErrorOnBlur } from '~/features/reservationInput/hooks/useErrorOnBlur'
import { sva } from '~/styled-system/css'
import { useDebouncedOnChange } from '../../hooks/useDebounce'
import { placeholder } from '../../lib/placeholder'
import { useReserverNameKana } from '../../store/stateMachine/context'
import { useReserverNameKanaError, useSetReserverNameKana } from '../../store/userInput'

const nameKanaStyles = sva({
  slots: ['container', 'heading', 'title', 'required', 'note', 'content'],
  base: {
    container: {
      spaceY: '1',
      _pc: {
        display: 'flex',
        alignItems: 'center',
        spaceY: '0',
        spaceX: '2',
      },
    },
    heading: {
      display: 'flex',
      alignItems: 'center',
      spaceX: '2',
      _pc: {
        display: 'block',
        spaceX: '0',
        width: '[188px]',
        flexShrink: '0',
        spaceY: '1',
      },
    },
    title: {
      display: 'flex',
      alignItems: 'center',
      fontSize: 'md',
    },
    required: {
      ml: '1',
      fontSize: 'sm',
      color: 'accent.pink',
    },
    note: {
      fontSize: 'xs',
    },
    content: {
      width: 'full',
      spaceY: '1',
    },
  },
})

export function NameKana({ children }: React.PropsWithChildren) {
  const classes = nameKanaStyles()
  return (
    <div className={classes.container}>
      <div className={classes.heading}>
        <p className={classes.title}>
          氏名（ひらがな）
          <span className={classes.required}>*</span>
        </p>
        <p className={classes.note}>※フルネーム</p>
      </div>
      <div className={classes.content}>{children}</div>
    </div>
  )
}

const nameKanaInputStyles = sva({
  slots: ['container', 'input'],
  base: {
    container: {
      width: 'full',
    },
  },
})

export function NameKanaInput() {
  const { onChange, error, onBlur, name } = useNameKanaInput()
  const classes = nameKanaInputStyles()
  return (
    <div className={classes.container}>
      <InputText
        errorMessage={error}
        width={300}
        placeholder={placeholder.nameKana}
        onChange={onChange}
        withSpread={true}
        onBlur={onBlur}
        defaultValue={name}
      />
    </div>
  )
}

function useNameKanaInput() {
  const name = useReserverNameKana()
  const change = useSetReserverNameKana()
  const onChange = useDebouncedOnChange(change, name)
  const nameKanaError = useReserverNameKanaError()
  const { error, onBlur } = useErrorOnBlur(nameKanaError)
  return { onChange, error, onBlur, name }
}
